import { useContext, useState } from "react";
// Hakikisha path ni sahihi kulingana na mradi wako
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaPaperPlane,
  FaClock,
  FaBuilding,
} from "react-icons/fa";
import { AppContext } from "../App";

export default function ContactLanding() {

	const appContext = useContext(AppContext);

  // State kwa ajili ya fomu ya maoni
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const form = new FormData();

      form.append("Jina Kamili", formData.name);
      form.append("Barua Pepe", formData.email);
      form.append("Kichwa", formData.subject);
      form.append("Ujumbe", formData.message);

      form.append("_subject", "Ujumbe Mpya Kutoka YCSC Website");
      form.append("_template", "table");
      form.append("_captcha", "false");

      const response = await fetch(
        "https://formsubmit.co/info@ycscsaccos.co.tz", //info@ycscsaccos.co.tz
        {
          method: "POST",
          body: form,
        },
      );

      if (response.ok) {
        setSubmitted(true);
		appContext.tellMessage("Email sent successfully")

        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });

        setTimeout(() => setSubmitted(false), 5000);
      }
    } catch (error) {
      console.error(error);
      appContext.tellError("Failed to send email")
    }
  };

  return (
    <div className="ycsc-contact-page bg-light pb-5 animate__animated animate__fadeIn">
      <div className="container mt-5 pt-2">
        <div className="row g-4">
          {/* UPANDE WA KUSHOTO: FOMU YA MAONI NA MREJESHO */}
          <div className="col-lg-7">
            <div className="card border-0 rounded-4 shadow-sm bg-white p-4 p-md-5 h-100">
              <div className="form-header mb-4">
                <h3 className="font-semi-bold text-dark mb-2">
                  Tuma Maoni au Mrejesho
                </h3>
                <p className="text-muted small">
                  Maoni yako ni muhimu sana kwetu. Jaza fomu hii na ujumbe wako
                  utatumwa moja kwa moja kwenda{" "}
                  <strong className="text-primary">
                    info@ycscsaccos.co.tz
                  </strong>
                </p>
              </div>

              {submitted && (
                <div className="alert alert-success border-0 rounded-3 font-semi-bold small mb-4 animate__animated animate__fadeIn">
                  Ahsante! Maoni yako yamepokelewa kikamilifu na yanafanyiwa
                  kazi na timu yetu.
                </div>
              )}

              <form onSubmit={handleSubmit} className="contact-premium-form">
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label font-semi-bold text-secondary small">
                        Jina Kamili
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="form-control rounded-3 py-2-5 font-regular"
                        placeholder="Mf. John Doe"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label font-semi-bold text-secondary small">
                        Barua Pepe (Email)
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="form-control rounded-3 py-2-5 font-regular"
                        placeholder="john@example.com"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="form-label font-semi-bold text-secondary small">
                        Kichwa cha Ujumbe (Subject)
                      </label>
                      <input
                        type="text"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        className="form-control rounded-3 py-2-5 font-regular"
                        placeholder="Mf. Swali la Akiba / Mkopo"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="form-label font-semi-bold text-secondary small">
                        Ujumbe wako / Maoni
                      </label>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        className="form-control rounded-3 font-regular"
                        rows="5"
                        placeholder="Andika ujumbe wako kwa kina hapa..."
                        required
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-12 pt-2">
                    <button
                      type="submit"
                      className="btn btn-primary btn-submit font-semi-bold w-100 rounded-3 py-3 d-flex align-items-center justify-content-center gap-2 shadow"
                    >
                      <FaPaperPlane size={14} />
                      <span>Tuma Ujumbe Sasa</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* UPANDE WA KULIA: ANUANI NA MAWASILIANO YA HUDUMA */}
          <div className="col-lg-5">
            <div className="d-flex flex-column gap-4 h-100">
              {/* KADI YA MAWASILIANO YA SIMU NA EMAIL */}
              <div className="card border-0 rounded-4 shadow-sm bg-white p-4 flex-grow-1">
                <h4 className="font-bold text-dark mb-4 border-start border-4 border-warning ps-2">
                  Mawasiliano ya Huduma
                </h4>

                <div className="d-flex flex-column gap-3">
                  {/* Namba za Simu */}
                  <div className="d-flex gap-3 align-items-start contact-info-row">
                    <div className="contact-icon-box bg-light text-primary rounded-3 d-flex align-items-center justify-content-center flex-shrink-0">
                      <FaPhoneAlt />
                    </div>
                    <div>
                      <span className="d-block text-muted tiny-label font-light">
                        Namba za Simu (Ofisi / Huduma)
                      </span>
                      <span className="d-block text-dark font-semi-bold">
                        +255 (0) 767 210 164
                      </span>
                      <span className="d-block text-dark font-semi-bold">
                        +255 (0) 717 451 746
                      </span>
                    </div>
                  </div>

                  {/* Barua Pepe */}
                  <div className="d-flex gap-3 align-items-start contact-info-row">
                    <div className="contact-icon-box bg-light text-primary rounded-3 d-flex align-items-center justify-content-center flex-shrink-0">
                      <FaEnvelope />
                    </div>
                    <div className="min-w-0">
                      <span className="d-block text-muted tiny-label font-light">
                        Barua Pepe Rasmi
                      </span>
                      <span className="d-block text-dark font-semi-bold text-truncate">
                        info@ycscsaccos.co.tz
                      </span>
                    </div>
                  </div>

                  {/* Saa za Kazi */}
                  <div className="d-flex gap-3 align-items-start contact-info-row">
                    <div className="contact-icon-box bg-light text-primary rounded-3 d-flex align-items-center justify-content-center flex-shrink-0">
                      <FaClock />
                    </div>
                    <div>
                      <span className="d-block text-muted tiny-label font-light">
                        Muda wa Kazi
                      </span>
                      <span className="d-block text-dark font-semi-bold">
                        Jumatatu - Ijumaa: 2:00 Asubuhi - 11:00 Jioni
                      </span>
                      <span className="d-block text-muted small font-regular">
                        Jumamosi na Jumapili: Tumefungwa
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* KADI YA ANUANI NA MAENEO HALISI */}
              <div className="card border-0 rounded-4 shadow-sm bg-white p-4 flex-grow-1">
                <h4 className="font-bold text-dark mb-4 border-start border-4 border-primary ps-2">
                  Anuani na Maeneo Halisi
                </h4>

                <div className="d-flex flex-column gap-3">
                  {/* Anuani ya Posta */}
                  <div className="d-flex gap-3 align-items-start contact-info-row">
                    <div className="contact-icon-box bg-light text-primary rounded-3 d-flex align-items-center justify-content-center flex-shrink-0">
                      <FaBuilding />
                    </div>
                    <div>
                      <span className="d-block text-muted tiny-label font-light">
                        Anuani ya Posta (Postal Address)
                      </span>
                      <span className="d-block text-dark font-semi-bold">
                        YCSC SACCOS LTD
                      </span>
                      <span className="d-block text-dark font-regular">
                        P.O BOX 90323 / S.L.P 90323
                      </span>
                      <span className="d-block text-dark font-regular">
                        Dar es Salaam, Tanzania
                      </span>
                    </div>
                  </div>

                  {/* Physical Location */}
                  <div className="d-flex gap-3 align-items-start contact-info-row">
                    <div className="contact-icon-box bg-light text-primary rounded-3 d-flex align-items-center justify-content-center flex-shrink-0">
                      <FaMapMarkerAlt />
                    </div>
                    <div>
                      <span className="d-block text-muted tiny-label font-light">
                        Eneo Halisi (Physical Location)
                      </span>
                      <span className="d-block text-dark font-semi-bold mb-1">
                        Eneo la Mikutano:
                      </span>
                      <span className="d-block text-muted font-regular small mb-2">
                        UDASA – Chuo Kikuu cha Dar es Salaam
                      </span>
                      <span className="d-block text-dark font-semi-bold mb-1">
                        Eneo la Ofisi Kuu:
                      </span>
                      <span className="d-block text-muted font-regular small">
                        Ubungo, Dar es Salaam (Tanzania)
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* GOOGLE MAPS AREA */}
        <div className="row mt-5">
          <div className="col-12">
            <div className="card border-0 rounded-4 shadow-sm overflow-hidden bg-white p-3">
              <h4 className="font-bold text-dark mb-3 d-flex align-items-center gap-2 px-1">
                <FaMapMarkerAlt className="text-danger" />
                <span>Ramani ya Ofisi (Ubungo)</span>
              </h4>

              {/* Iframe ya Ramani kwa ajili ya Muonekano thabiti */}
              <div className="contact-map-wrapper rounded-3 overflow-hidden">
                <iframe
                  title="YCSC SACCOS Location Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31694.944852208133!2d39.18708577330745!3d-6.78590065025931!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x185c492bb03fa317%3A0x3067ed157d644400!2sUbungo%2C%20Dar%20es%20Salaam!5e0!3m2!1sen!2stz!4v1782369013934!5m2!1sen!2stz"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
